import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import _indexOf from 'lodash/indexOf';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { purgeStoredState } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';

import { preserveDataNoIntent, cancelEmailFormNoIntent, sendEmailNoIntent } from '../actions/action-email-form-no-intent';
import { WebForm } from '../components/common/index';
import { trackLink } from '../../lib/analytics-helper';
import * as shape from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { hideSubmitButton } from '../../lib/emailUtil';

const isSmcEnabled = Page.getIsSmcEnabled();

const emailUs = {
  submit: i18n.message('smarthelp/emailUs.emailUs.submit'),
  reset: i18n.message('smarthelp/emailUs.emailUs.reset'),
  errors: i18n.message('smarthelp/emailUs.emailUs.errors'),
};


class EmailForm extends Component {
  static getCustomFieldPayLoad(formFields) {
    let customFieldPayLoad = [];

    if (!_isEmpty(formFields) && formFields.length >= 1) {
      customFieldPayLoad = formFields.map(field => _pick(field, ['name', 'value']));
    }

    return customFieldPayLoad;
  }

  static getCustomFields(formData) {
    let formFields = [];
    let payload = [];

    if (!_isEmpty(formData) && formData.length > 1) {
      formFields = formData.filter((field) => {
        const fieldTypes = ['text', 'number', 'textarea', 'date', 'select'];
        if (_indexOf(fieldTypes, field.type) > -1) {
          if (field.type === 'textarea' && field.label === 'Message') {
            return false;
          }
          return true;
        }
        return false;
      });

      payload = EmailForm.getCustomFieldPayLoad(formFields);
    }

    return payload;
  }

  getWebForm() {
    return (
      <div className="form-fields">
        <WebForm
          fields={this.props.fieldDetails}
          submitLabel={emailUs.submit}
          resetLabel={emailUs.reset}
          errors={emailUs.errors}
          handleFieldValue={this.props.preserveDataNoIntent}
          handleCancel={this.cancelEmailForm()}
          handleSubmit={this.handleFormSubmit()}
          submitButtonStyle={`left-col col-xs-6 col-sm-6 col-md-6 col-lg-6
            ${hideSubmitButton(this.props.fieldDetails)}`}
          cancelButtonStyle="right-col col-xs-6 col-sm-6 col-md-6 col-lg-6"
        />
      </div>
    );
  }

  getContainer() {
    let emailContainer = null;
    purgeStoredState({ storage: asyncSessionStorage }).then(() => {
    });
    if (this.props.display) {
      emailContainer = (
        <div className="email-us-container">
          {this.getWebForm()}
        </div>
      );
    } else if (this.props.error) {
      emailContainer = (
        <div className="error-email-no-intent">
          <div className="vx_icon vx_icon-large vx_icon-critical-large test" />
          <div className="error-message-email-no-intent">{emailUs.errors.message}</div>
        </div>
      );
    }
    return emailContainer;
  }

  handleFormSubmit() {
    return (formData) => {
      const messageField = _find(formData, { type: 'textarea' });
      trackLink({ id: 'emailByPassPage', link: `smarthelp-submit-email-form|${this.props.selectedDetails.topicName}` });
      const payload = {
        message: _get(messageField, 'value', ''),
        topic_code: this.props.selectedDetails.kanaCode,
        subject: this.props.selectedDetails.subTopicName,
        topicName: this.props.selectedDetails.topicName,
        subTopicName: this.props.selectedDetails.subTopicName,
        custom_fields: EmailForm.getCustomFields(formData),
        _csrf: Page.getCSRFtoken(),
      };
      const thankyouPageDescription = Page.getEmailThankYouPageDescription(this.props.topicTreeSelectionL1Reference);
      this.props.sendEmailNoIntent({ emailPayload: payload, hasCommunityAccess: this.props.hasCommunityAccess, isSmcEnabled, thankyouPageDescription });
    };
  }

  cancelEmailForm() {
    return () => {
      trackLink({ id: 'emailByPassPage', link: `smarthelp-cancel-email-form|${this.props.selectedDetails.topicName}` });
      this.props.cancelEmailFormNoIntent();
    };
  }
  render() {
    return this.getContainer();
  }
}

function mapStateToProps(state) {
  return {
    hasCommunityAccess: (state.contactChannels.channels.some(channel => channel.type === 'community')),
    fieldDetails: state.emailNoIntent.fields,
    selectedDetails: {
      topicId: state.emailNoIntent.fieldPrefix,
      kanaCode: state.emailNoIntent.kanaCode,
      topicName: state.emailNoIntent.topicName,
      subTopicName: state.emailNoIntent.subTopicName,
      pageflow: '',
    },
    topicTreeSelectionL1Reference: state.topicTree.topicTreeSelectionL1 ? state.topicTree.topicTreeSelectionL1.ref_id : undefined,
    display: state.emailNoIntent.display,
    error: state.emailNoIntent.error,
  };
}


EmailForm.propTypes = {
  fieldDetails: PropTypes.arrayOf(PropTypes.shape(shape.WEBFORM_FIELDS_DETAILS)),
  selectedDetails: PropTypes.shape(shape.WEBFORM_OTHER_FIELD_DETAILS),
  preserveDataNoIntent: PropTypes.func.isRequired,
  cancelEmailFormNoIntent: PropTypes.func.isRequired,
  sendEmailNoIntent: PropTypes.func.isRequired,
  display: PropTypes.bool,
  hasCommunityAccess: PropTypes.bool,
  error: PropTypes.bool,
  topicTreeSelectionL1Reference: PropTypes.string,
};


function mapDispatchToProps(dispatch) {
  return bindActionCreators({ preserveDataNoIntent, cancelEmailFormNoIntent, sendEmailNoIntent }, dispatch);
}

EmailForm.defaultProps = {
  fieldDetails: [],
  selectedDetails: {},
  display: false,
  hasCommunityAccess: false,
  error: false,
  topicTreeSelectionL1Reference: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailForm);
